import {Injectable} from '@angular/core';

@Injectable()
export class SidebarService {
  isOpen = true;
  selectedMenuOption = '';
  selectedGroupOptionControll = false;
  selectedGroupOptionStandards = false;
  selectedSL = false;
  selectedGroupOptionOpStandards = false;
  selectedStandardsManagement = false;

  openSideBar() {
    this.isOpen = !this.isOpen;
    localStorage.setItem('NavBar', String(this.isOpen));
  }

  closeSideBar() {
    this.isOpen = false;
  }

  setSideBar(f) {
    this.isOpen = f;
  }

  setSelectedMenuOption(opt) {
    this.selectedMenuOption = opt;
  }

  setSelectedGroupOptionControll(flag) {
    this.selectedGroupOptionControll = flag;
  }

  setSelectedGroupOptionStandards(flag) {
    this.selectedGroupOptionStandards = flag;
  }

  setSelectedSL(flag) {
    this.selectedSL = flag;
  }

  setSelectedGroupOptionOpStandards(flag) {
    this.selectedGroupOptionOpStandards = flag;
  }

  setSelectedStandardsManagement(flag) {
    this.selectedStandardsManagement = flag;
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/services/side-bar.service.ts